import React, { useState } from 'react';
import { IconButton, TableCell, useTheme } from '@mui/material';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { getBodyCellSx } from '@features/calibration/components/shared/utils';
import MeasurementImageDialog from './MeasurementImageDialog';

type MeasurementImageActionProps = {
  imageId?: string;
  runId?: string;
};

export const MeasurementImageAction: React.FC<MeasurementImageActionProps> = ({
  imageId,
  runId
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  if (!imageId || !runId) return null;

  return (
    <>
      <IconButton size="small" onClick={() => setDialogOpen(true)}>
        <CameraAltIcon fontSize="small" />
      </IconButton>
      <MeasurementImageDialog
        open={dialogOpen}
        runId={runId}
        imageId={imageId}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};

type MeasurementImageCellProps = {
  imageId?: string;
  runId?: string;
  section: 'asFound' | 'asLeft';
};

const MeasurementImageCell: React.FC<MeasurementImageCellProps> = ({
  imageId,
  runId,
  section
}) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <TableCell sx={getBodyCellSx(section, isDarkMode)} align="center">
      <MeasurementImageAction imageId={imageId} runId={runId} />
    </TableCell>
  );
};

export default MeasurementImageCell;
